import { forwardRef } from 'react';
import { t } from '@lingui/macro';
import { TextArea } from '@pocketlaw/tetris';
import { useField, useFormikContext } from 'formik';
import { useAssistant } from 'app/domains/assistant';
import { SubmitButton } from './SubmitButton';
import { Container } from './styled';
export const ChatInput = forwardRef((_, forwardedRef) => {
    const [field] = useField('message');
    const { submitForm } = useFormikContext();
    const { loading, hasCredits } = useAssistant();
    const disabled = loading || !hasCredits;
    const label = t({
        message: `Type your question`,
        comment: 'Document assistant chat textarea placeholder',
    });
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            submitForm();
        }
    };
    return (<Container>
      <TextArea {...field} ref={forwardedRef} stretch variant="outline" autoComplete="off" disabled={disabled} label={label} onKeyDown={handleKeyDown}/>
      <SubmitButton />
    </Container>);
});
